export default __webpack_public_path__ + "guide--vector-tiles-standards-ccw-960-f9bab1cf8e451afe1027a14b8adaf9c9.webp";